'use client';

import { useState } from 'react';
import Link from 'next/link';
import { homeFaqs } from './home-faq-data';

export default function HomeFaq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const toggle = (i: number) => {
    setOpenIndex((prev) => (prev === i ? null : i));
  };

  return (
    <section className="py-16 lg:py-24 bg-[var(--color-off-white)]">
      <div className="container">
        <div className="max-w-[48rem] mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-2xl lg:text-3xl font-bold mb-4">
              Custom Printing in the UK — Frequently Asked Questions
            </h2>
            <p className="text-[var(--color-text-secondary)]">
              Straight answers about pricing, delivery, minimums and print methods. Still unsure?{' '}
              <Link href="/contact" className="underline hover:no-underline">
                Talk to our team
              </Link>
              .
            </p>
          </div>

          <div className="divide-y divide-[var(--color-border)] border-t border-b border-[var(--color-border)] bg-white">
            {homeFaqs.map((item, i) => {
              const isOpen = openIndex === i;
              return (
                <div key={i}>
                  <button
                    type="button"
                    onClick={() => toggle(i)}
                    aria-expanded={isOpen}
                    className="w-full flex items-center justify-between gap-4 px-5 py-5 text-left hover:bg-[var(--color-off-white)] transition-colors"
                  >
                    <span className="text-base lg:text-lg font-semibold pr-2">{item.q}</span>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth={2}
                      stroke="currentColor"
                      className={`w-5 h-5 shrink-0 transition-transform duration-200 ${isOpen ? 'rotate-45' : ''}`}
                      aria-hidden="true"
                    >
                      <path strokeLinecap="round" strokeLinejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
                    </svg>
                  </button>
                  {isOpen && (
                    <div className="px-5 pb-6 text-sm lg:text-base text-[var(--color-text-secondary)] leading-relaxed">
                      {item.a}
                    </div>
                  )}
                </div>
              );
            })}
          </div>

          <p className="text-center text-sm text-[var(--color-text-secondary)] mt-8">
            See our full{' '}
            <Link href="/faq" className="underline hover:no-underline">
              FAQ page
            </Link>{' '}
            for more detail on ordering, artwork and returns.
          </p>
        </div>
      </div>
    </section>
  );
}
